

export class AdHocCustomPopupProcessor {

    constructor(
        public $window: ng.IWindowService) {

        return;
    }

    public getExistingValue(columnName: string) {

        var htmlInputId = this.getQueryVariable('valueeditid');
        var isReportDesigner: boolean = (htmlInputId.toLowerCase().indexOf('reportdesigner') >= 0);

        var existingValue = isReportDesigner
            ? $(".iz-table-filters option[value='" + columnName + "']:selected", this.$window.parent.document).first().closest('tr').find("input[name=popup_value_handler]").val()
            : (<HTMLInputElement>(this.$window.parent.document.getElementById(htmlInputId))).value;

        var ret = (existingValue === "...")
            ? ""
            : existingValue;

        return ret;
    }

    public getQueryVariable(variable) {

        var query = this.$window.location.search.substring(1);
        var vars = query.split('&');

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) === variable) {
                return decodeURIComponent(pair[1]);
            }
        }

        return null;
    }

    public getColumnName(): string {

        var htmlInputId = this.getQueryVariable('columneditid');
        var columnName = (<HTMLInputElement>(this.$window.parent.document.getElementById(htmlInputId))).value;

        return columnName;
    }

}
